var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{on:{"click":function($event){return _vm.gotoPerson(_vm.pessoa)}}},[_c('strong',[_vm._v(_vm._s(_vm.pessoa.label || _vm.pessoa.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }